"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("react");
var BaseFeatureWidget_1 = require("./BaseFeatureWidget");
var Plugin_1 = __importDefault(require("./Plugin"));
var coreRpcMethods = __importStar(require("./rpc/coreRpcMethods"));
var WidgetType_1 = __importDefault(require("./pluggableElementTypes/WidgetType"));
var CytobandAdapter_1 = __importDefault(require("./data_adapters/CytobandAdapter"));
// the core plugin, which registers types that ALL JBrowse applications are
// expected to need.
var CorePlugin = /*#__PURE__*/function (_Plugin_1$default) {
  _inherits(CorePlugin, _Plugin_1$default);
  function CorePlugin() {
    var _this;
    _classCallCheck(this, CorePlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CorePlugin).apply(this, arguments));
    _this.name = 'CorePlugin';
    return _this;
  }
  _createClass(CorePlugin, [{
    key: "install",
    value: function install(pluginManager) {
      // register all our core rpc methods
      Object.values(coreRpcMethods).forEach(function (RpcMethod) {
        pluginManager.addRpcMethod(function () {
          return new RpcMethod(pluginManager);
        });
      });
      (0, CytobandAdapter_1.default)(pluginManager);
      pluginManager.addWidgetType(function () {
        return new WidgetType_1.default({
          name: 'BaseFeatureWidget',
          heading: 'Feature details',
          configSchema: BaseFeatureWidget_1.configSchema,
          stateModel: (0, BaseFeatureWidget_1.stateModelFactory)(pluginManager),
          ReactComponent: (0, react_1.lazy)(function () {
            return Promise.resolve().then(function () {
              return __importStar(require('./BaseFeatureWidget/BaseFeatureDetail'));
            });
          })
        });
      });
    }
  }]);
  return CorePlugin;
}(Plugin_1.default);
exports.default = CorePlugin;